// D1 — THE single frontend date-range resolver (mirrors backend resolve_range; Meta Ads Manager convention, Asia/Taipei).
// 近 N 天 = N full days ending YESTERDAY · 今天 = today · 本月 = 1st→today · 上月 = full previous month · custom = inclusive.
const DAYS = { "7d": 7, last_7d: 7, "14d": 14, last_14d: 14, "30d": 30, last_30d: 30, "90d": 90, last_90d: 90, "180d": 180, "365d": 365 };

const pad = (n) => String(n).padStart(2, "0");
const iso = (d) => `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`;
const addDays = (d, n) => new Date(d.getTime() + n * 86400000);

export function todayTpe() {
  const t = new Date(Date.now() + 8 * 3600000);
  return new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()));
}

export function resolveRange(key = "30d", start = null, end = null) {
  const today = todayTpe();
  const k = (key || "30d").toLowerCase();
  let s, u, label;
  if (k === "custom" && start && end) {
    return { key: "custom", since: String(start).slice(0, 10), until: String(end).slice(0, 10), label: `${String(start).slice(0, 10)} ~ ${String(end).slice(0, 10)}` };
  }
  if (k === "today") { s = u = today; label = "今天"; }
  else if (k === "yesterday") { s = u = addDays(today, -1); label = "昨天"; }
  else if (k === "this_month") { s = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 1)); u = today; label = "本月"; }
  else if (k === "last_month") {
    u = addDays(new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 1)), -1);
    s = new Date(Date.UTC(u.getUTCFullYear(), u.getUTCMonth(), 1)); label = "上月";
  } else if (k === "this_year") { s = new Date(Date.UTC(today.getUTCFullYear(), 0, 1)); u = today; label = "今年"; }
  else if (k === "all") { s = new Date(Date.UTC(2024, 0, 1)); u = today; label = "全部時間"; }
  else { const n = DAYS[k] || 30; u = addDays(today, -1); s = addDays(u, -(n - 1)); label = `近 ${n} 天`; }
  return { key: k, since: iso(s), until: iso(u), label };
}

export const rangeText = (r) => (r ? `${r.since} ~ ${r.until}` : "");
